// extracted by mini-css-extract-plugin
export default {"courses":"Courses_courses__7XtJv"};